import { SearchOutput, SearchUseCase } from './search-use-case';
import { GeneralSearchUseCase } from './general-search';

export class GeneralSearchSheetsUseCase implements SearchUseCase {
  constructor(
    private readonly isComparisonMode: boolean = false,
    private readonly shouldRedirectToPrimeComparison: boolean = false
  ) {}

  async execute(term: string): Promise<SearchOutput> {
    let result = await GeneralSearchUseCase.getAssets(term);

    if (!this.isComparisonMode) {
      result = result
        .filter((asset) => {
          // Se deve redirecionar para comparação prime, mantém o asset
          if (this.shouldRedirectToPrimeComparison) return true;
          // Se tem canonical_url, mantém o asset
          if (asset.canonical_url) return true;
          // Caso contrário, remove o asset
          return false;
        })
        .map((asset) => {
          if (!asset.canonical_url) {
            // Adiciona URL de comparação apenas se não tiver canonical_url
            asset.canonical_url = `app/comparador-ativos?p=otimo&a=${encodeURIComponent(
              asset.identifier
            )}`;
          }
          return asset;
        });
    }

    if (result?.length === 0) {
      return {
        categories: [{ label: 'Tudo', disabled: false, slug: 'all' }],
        groupedAssets: {},
      };
    }

    const formattedAssets = GeneralSearchUseCase.assetsFormatter(result);
    const groupedAssets =
      GeneralSearchUseCase.groupAssetsByCategory(formattedAssets);

    return groupedAssets;
  }
}
